import { LILAC_200, LILAC_500, tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getAccordionListWidgetStyles = () => {
  return StyleSheet.create({
    content: {
      marginTop: tokens.spacing.SPACING_6
    },
    collapsibleContainer: {
      paddingVertical: tokens.spacing.SPACING_12,
      paddingHorizontal: tokens.spacing.SPACING_16
    },
    accordionListHeading: {
      marginBottom: tokens.spacing.SPACING_20
    },
    accordionListWrapper: {
      marginBottom: tokens.spacing.SPACING_20
    },
    title: {
      flexShrink: 1
    },
    viewAllCta: {
      paddingVertical: tokens.spacing.SPACING_16,
      alignSelf: 'center'
    },
    viewAllCtaButton: {
      paddingTop: tokens.spacing.SPACING_10,
      paddingLeft: tokens.spacing.SPACING_32
    },
    adjustSize: {
      flex: 1
    },
    noDataWrapper: {
      padding: tokens.spacing.SPACING_32,
      backgroundColor: LILAC_200,
      borderColor: LILAC_500,
      borderWidth: 1,
      borderRadius: tokens.spacing.SPACING_16
    },
    textWithIcon: {
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'row'
    },
    iconSpacer: {
      marginRight: tokens.spacing.SPACING_8
    },
    itemSpacer: {
      marginTop: tokens.spacing.SPACING_8
    },
    titleComponent: {
      flexDirection: 'row',
      flex: 1
    },
    titleComponentImage: {
      flexShrink: 0
    },
    titleComponentText: {
      flex: 1
    },
    titleContent: {
      flex: 1
    },
    safePadding: {
      paddingTop: tokens.spacing.SPACING_5
    },
    l2TitleSpacing: {
      paddingLeft: tokens.spacing.SPACING_48
    },
    displayNone: {
      display: 'none'
    },
    calloutStyle: {
      marginBottom: tokens.spacing.SPACING_16
    }
  });
};